export default {
  getAll: {
    url: '/api/transfer/getAll',
    method: 'get'
  },
  create: {
    url: '/api/transfer/create',
    method: 'post'
  },
  update: {
    url: '/api/transfer/update',
    method: 'put'
  },
  delete: {
    url: '/api/transfer/delete',
    method: 'delete'
  }
}



// WEBPACK FOOTER //
// ./src/api/transfer.js